import { render } from "./courseMajorDisplay.vue?vue&type=template&id=61af2edb&scoped=true"
import script from "./courseMajorDisplay.vue?vue&type=script&lang=js"
export * from "./courseMajorDisplay.vue?vue&type=script&lang=js"

import "./courseMajorDisplay.vue?vue&type=style&index=0&id=61af2edb&scoped=true&lang=css"
import "./courseMajorDisplay.vue?vue&type=style&index=1&id=61af2edb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61af2edb"]])

export default __exports__